/*global customDIM*/
let initialized = false;
let partList = [];
let principalPart = null;
let designPart = null; // Zona de diseño para colores complejos
let designList = [] // Almacena la lista de diseños obtenida de la API

let apiCallHistory = [];


/**
 * Comprueba si esta inicializado el canvas 3D
 * @returns {Boolean} Si se encuentra inicializado o no
 **/
const checkIsInitialized = () => {
    if (!initialized) {
        console.warn("El canvas 3D no está inicializado")
        return false;
    }

    return true;
}


let apiCallQueue = Promise.resolve();

/**
 * Función para encapsular las llamadas a customDIM.api.call
 * @param {String} method Método a llamar en la API
 * @returns {Promise} Promesa con el resultado de la llamada
 **/
const apiCall = (method) => {
    if (!method.endsWith(')')) {
        method += '()';
    }
    apiCallQueue = apiCallQueue.then(() => {
        return new Promise((resolve, reject) => {
            customDIM.api.call(method, (result) => {
                console.log(`💻 [DIM UTILS] ~ apiCall ~ ${method} result:`, result);
                apiCallHistory.push({ method, result });
                console.log("💻 ~ apiCall ~ apiCallHistory:", apiCallHistory)
                resolve(result);
            }, (error) => {
                console.error(`💻 [DIM UTILS] ~ apiCall ~ ${method} error:`, error);
                reject(error);
            });
        });
    });
    return apiCallQueue;
};

/**
 * Función para recuperar la parte principal de la prenda (aquella en la que podemos asignar colores)
 * @returns {Object} Objeto con la parte obtenida
 * @throws {Error} Error si no se ha inicializado el canvas 3D, o si no se encuentra la zona principal
 **/
const getPrincipalPart = () => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (!principalPart) {
        console.log("💻 ~ Buscando la parte principal", partList);
        principalPart = partList?.find(p => p.customizationOptions.some(c => c == "colours"))

        if (!principalPart) {
            throw new Error("No hemos podido encontrar la parte principal del modelo")
        }
    }

    return principalPart;
}

/**
 * Obtiene la parte de diseño del modelo 3D.
 * 
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se encuentra la zona de diseño del modelo.
 * @returns {Object} La parte de diseño encontrada en la lista de partes.
 **/
const getDesignPart = () => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado");
    }

    if (!designPart) {
        console.log("💻 ~ Buscando la zona de diseño", partList);
        designPart = partList?.find(p => p.customizationOptions.some(c => c == "design"));

        if (!designPart) {
            throw new Error("No hemos podido encontrar la zona de diseño del modelo");
        }
    }

    return designPart;
}

/**
 * Función para buscar un modelo en la API y cargarlo
 * @param {String} idModel Modelo que queremos buscar para cargar
 * @returns {Promise} Promesa con el listado de partes que tenemos
 **/
export const searchModelOnApiAndSetActive = (idModel = 6554) => {
    console.log("💻 ~ customDIM.api.call ~ Searching:", idModel, customDIM.state.iframe.contentWindow)

    return apiCall('model.getGroups').then(result => {
        console.log("💻 ~ file: customDimUtils.js:73 ~ returnapiCall ~ result:", result)

        if (!result || !result.length) {
            return Promise.reject('No se ha encontrado el modelo')
        }

        let model = result.find(m => m.sku.sku == idModel);
        console.log("💻 ~ customDIM.api.call ~ model:", model, model?.id)

        if (!model) {
            return Promise.reject('No se ha encontrado el modelo')
        }

        return apiCall(`model.setGroup(${model.id})`);
    }).then(() => {
        return apiCall('part.getList')
    }).then(result => {
        partList = result;
        return result;
    });
}


/**
 * Verifica la inicialización del entorno necesario para trabajar con canvas y la librería customDIM.
 * 
 * @param {Function} reject - Función de rechazo que se ejecutará si no se encuentra el canvas o la librería customDIM.
 * @returns {HTMLCanvasElement} - El elemento canvas encontrado en el DOM.
 * @throws {Error} - Lanza un error si el canvas o la librería customDIM no están disponibles.
 **/
const checkInit = (reject) => {
    const canvas = document.getElementById('canvas3d');

    if (!canvas) {
        reject('Canvas no encontrado');
    }

    // Comprobamos que existe la librería customDIM
    if (!customDIM) {
        reject('customDIM no encontrado');
    }

    return canvas;
}



/**
 * Función que inicializa el canvas 3D
 * @param {String} json Objeto con la personalización actual, y donde se van a guardar la personalización actual
 * @param {String} idModel id del configurador
 * @returns {Promise} Promesa que se encarga de generar
 **/
export const init3DCanvas = (json, idModel = 4, callback = {}) => {

    const defaultCallbacks = {
        click3D: console.debug,
        clickDesign3D: console.debug,
        activeText3D: console.debug,
        deleteText3D: console.debug,
        fixText3D: console.debug,
        scaleText3D: console.debug,
        rotateText3D: console.debug,
        outlineText3D: console.debug,
        moveText3D: console.debug,
        layerText3D: console.debug,
        activeImage3D: console.debug,
        deleteImage3D: console.debug,
        fixImage3D: console.debug,
        scaleImage3D: console.debug,
        rotateImage3D: console.debug,
        moveImage3D: console.debug,
        layerImage3D: console.debug
    };

    const callbacks = { ...defaultCallbacks, ...callback };
    const customizationPayload = (() => {
        if (!json) {
            return null;
        }

        if (typeof json === 'string') {
            return json.trim() ? json : null;
        }

        if (Array.isArray(json)) {
            return json.length ? json : null;
        }

        if (typeof json === 'object') {
            return Object.keys(json).length ? json : null;
        }

        return json;
    })();
    console.log("💻 ~ init3DCanvasAndSearchByIdsap ~ idModel:", idModel)

    return new Promise((resolve, reject) => {
        // Comprobamos que existe el elemento con id canvas3d
        checkInit(reject);

        if (!idModel) {
            reject('No se ha proporcionado un idModel');
        }

        // Inicializamos el canvas 3D
        customDIM.install('canvas3d', 'gorfactoryTest', null, idModel, customizationPayload, () => {
            console.log("💻 ~ onAvalibleAPICustomDIM")
            // initialized = true;
            apiCall('part.getList').then(result => {
                console.log("💻 ~ file: customDimUtils.js:165 ~ customDIM.install ~ result: @", result)
                partList = result;

                let queue = Promise.resolve();

                try {
                    designPart = result?.find(p => p.customizationOptions.some(c => c == "design"));

                    if (designPart) {
                        queue.then(() => apiCall(`design.getListByPart( ${designPart.id})`).then(resultDesign => {
                                console.log("💻 ~ file: customDimUtils.js:170 ~ customDIM.install ~ result:", result)
                                designList = resultDesign;
                            }
                        ));
                    }
                    
                }
                catch {
                    console.warn("No hemos podido encontrar la parte de diseño")
                }
                

                return queue.then(() => {
                    initialized = true
                    resolve(result)
                })
            })


        }, () => {
            console.log("💻 ~ onFinalizedCustomDIM")
        }, () => {
            console.log("💻 ~ onChangeCustomDIM”:")
        }, callbacks);


    })
}


/**
 * Función para cargar un color en el modelo 3d
 * @param {String} colorCode Código de color que queremos seleccionar
 * @param {String} [type="hexcode"] Tipo de código de color, puede ser "hexcode" o "colorcode"
 * @returns {Promise} Promesa con la llamada a la función
 **/
export const loadColor = (colorCode, type = "hexcode") => {

    if (!colorCode) {
        console.warn("Nos debe proporcionar un color válido")
        return;
    }

    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (type === "hexcode") {
        const hexcode = (colorCode?.hexcode || colorCode).replace("#", "");
        console.log("💻 ~ loadColor ~ hexcode:", hexcode)

        // Buscamos en la partList aquella que tiene como customizationOptions

        principalPart = getPrincipalPart();
        console.log("💻 ~ loadColor ~ principalPart:", principalPart)

        return apiCall(`design.setColourOfPieceByPart( ${principalPart.id}, 0, '${hexcode}' )`);
    }
    else if (type === "colorcode") {
        designPart = getDesignPart();

        if (!designPart) {
            return Promise.reject("No hemos podido encontrar la parte de diseño")
        }

        if (!designList || !designList.length) {
            return Promise.reject("No hemos podido encontrar diseños disponibles")
        }

        let color = designList.find(c => c.sku?.sku == colorCode);

        if (!color || !color.id) {
            return Promise.reject("No hemos encontrado el color en la parte de diseño " + colorCode)
        }

        return apiCall(`design.setActiveByPart( ${designPart.id}, '${color.id}' )`);
    }
    else {
        return Promise.reject("El tipo de color no es correcto")
    }

}


/**
 * Función para cargar una zona en concreto
 * @param {Object} Zona zona en la que se quiere cambiar el modelo
 * @returns {Promise} Promesa con la llamada a la función
 **/
export const setActiveZone = ({ id, Posicion, Zona, Animation } = {}) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (id < 0 || !Posicion || !Zona) {
        console.warn("Nos debe proporcionar una zona válida")
        return Promise.resolve()
    }

    console.log('💻 ~ setActiveZone ~ request:', { id, Posicion, Zona, Animation });
    console.log("💻 ~ setActiveZone ~ partList (len):", partList?.length);

    let informationZone = partList.find(p => {
        if (typeof p.sku == 'number') {
            return p.sku == Posicion
        }

        return p.sku?.sku == Posicion
    });

    console.log("💻 ~ setActiveZone ~ matchedBySku:", informationZone)

    if (!informationZone) {
        // Try alternative matches: normalize name, or check skus array
        const actualZone = Zona?.replace(/\s+/g, '')?.replace(/_/g, ' ')?.toUpperCase();
        console.log("💻 ~ setActiveZone ~ trying name match for:", actualZone)

        informationZone = partList.find(p => p.name == actualZone);

        if (!informationZone) {
            // Some parts may expose skus as arrays in p.skus
            informationZone = partList.find(p => Array.isArray(p.skus) && p.skus.includes(Posicion));
            console.log('💻 ~ setActiveZone ~ matchedBySkusArray:', informationZone);
        }
    }

    if (!informationZone) {
        console.error("No se ha podido encontrar la zona ", Posicion, Zona, partList);
        throw new Error("No hemos podido encontrar la zona")
    }

    console.log('💻 ~ setActiveZone ~ informationZone.customizationOptions:', informationZone.customizationOptions)

    if (!informationZone.customizationOptions.some(c => c == "images")) {
        console.error("La zona encontrada no soporta imágenes:", Posicion, Zona, informationZone);
        throw new Error("La zona encontrada no soporta imágenes")
    }

    if(Animation == undefined) {
        Animation = 1000;
    }

    return new Promise((resolve, reject) => {
        console.log(`💻 ~ setActiveZone ~ calling part.setActive id=${informationZone.id} animation=${Animation}`)
        apiCall(`part.setActive(${informationZone.id}, ${Animation})`).then((res) => {
            console.log('💻 ~ setActiveZone ~ part.setActive result:', res)
            resolve(informationZone)
        }).catch(err => {
            console.error('💻 ~ setActiveZone ~ part.setActive error:', err)
            reject(err)
        });
    })
}


/**
 * Busca una zona en la lista de partes utilizando un ID 3D.
 * 
 *
 * @param {string|number} id - El ID único del objeto 3D que se desea buscar.
 * @returns {Object|undefined} - Retorna el objeto encontrado en la lista de partes, o `undefined` si no se encuentra.
 * @throws {Error} - Lanza un error si el canvas 3D no está inicializado o si no se proporciona un ID válido.
 **/
export const findZoneBy3dId = (id) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (!id) {
        throw new Error("No ha proporcionado un id válido")
    }

    return partList.find(p => p.id == id);
}

/**
 * Calcula el número de incrementos necesarios para ajustar la escala actual
 * de un objeto al tamaño deseado, basado en un tamaño original.
 *
 * @param {number} tamanoOriginal - Tamaño original del objeto.
 * @param {number} escalaActual - Escala actual del objeto.
 * @param {number} tamanoDeseado - Tamaño deseado del objeto.
 * @returns {number} Número de incrementos necesarios para ajustar la escala.
 */
export const calcularIncrementoEscala = (tamanoOriginal, escalaActual, tamanoDeseado, step = 0.02) => {
    // Calculamos cuál debería ser la nueva escala para lograr el tamaño deseado
    const escalaDeseada = tamanoDeseado / tamanoOriginal;

    // Calculamos la diferencia de escala
    const diferenciaEscala = escalaDeseada - escalaActual;

    // Cada incremento representa 0.02 en la escala
    const incrementos = diferenciaEscala / step;

    return incrementos;
}

/**
 * Convierte dimensiones px -> mm usando mask pixel dimensions + real dimensions
 * @param {Object} activeZone 
 * @param {Number|String} dimensionPxWidth  - ancho del diseño en px
 * @param {Number|String} dimensionPxHeight - alto del diseño en px
 * @param {Number|String} scale - escala aplicada al diseño
 * @param {Number} realAreaWidthMm - ancho real imprimible en mm
 * @param {Number} realAreaHeightMm - alto real imprimible en mm
 * @returns {{ widthMm: number, heightMm: number }}
 */
export const estimateRealMmDimensions = (
    activeZone,
    dimensionPxWidth,
    dimensionPxHeight,
    scale,
    realAreaWidthMm,
    realAreaHeightMm
) => {

    if (!activeZone?.canvas?.mask) {
        return { widthMm: 0, heightMm: 0 };
    }

    const maskWidthPx = activeZone.canvas.mask.width;
    const maskHeightPx = activeZone.canvas.mask.height;

    const parsedWidthPx = parseFloat(dimensionPxWidth) || 0;
    const parsedHeightPx = parseFloat(dimensionPxHeight) || 0;
    const parsedScale = parseFloat(scale) || 1;

    const designWidthPx = parsedWidthPx * parsedScale;
    const designHeightPx = parsedHeightPx * parsedScale;

    const widthMm =
        maskWidthPx > 0 ? (designWidthPx / maskWidthPx) * realAreaWidthMm : 0;

    const heightMm =
        maskHeightPx > 0 ? (designHeightPx / maskHeightPx) * realAreaHeightMm : 0;

    return {
        widthMm: Math.round(widthMm),
        heightMm: Math.round(heightMm),
    };
};


/**
 * Carga texto en la zona activa del canvas 3D.
 * 
 * @param {string} text - El texto a cargar en la zona.
 * @param {Object} activeZone - La zona activa donde se añadirá el texto, debe contener un `id`.
 * @param {number} [fontSelected=1] - ID de la fuente a utilizar (por defecto 1).
 * @returns {Promise<Object>} - Promesa que resuelve con el objeto del texto añadido, incluyendo propiedades como `scale` y `mode: 'TEXT'`.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona una zona activa válida.
 **/
export const uploadText = async (text, activeZone, realWidth, realHeight, fontSelected = 1, colorPicker = '000000') => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (!activeZone?.id) {
        throw new Error("No ha proporcionado la zona activa")
    }

    if (colorPicker.startsWith('#')) {
        colorPicker = colorPicker.replace('#', '');
    }

    return await apiCall(`design.text.addToPart(${activeZone.id},'${text}', ${fontSelected}, '${colorPicker}')`).then(async () => {
        return await apiCall(`design.text.getListByPart( ${activeZone.id} )`).then(result => {
            let actualTextOn3d = result.find(i => i.text == text);
            if (!actualTextOn3d) {
                console.warn("No hemos encontrado el texto a recuperar la escala", text, activeZone, result)
                return;
            }

            let sizeText = estimateRealMmDimensions(activeZone, actualTextOn3d.currentDimensions.width, actualTextOn3d.currentDimensions.height, actualTextOn3d.scale, realWidth, realHeight)
            console.log("🚀 ~ uploadText ~ sizeText:", sizeText, activeZone, actualTextOn3d.currentDimensions.width, actualTextOn3d.currentDimensions.height, actualTextOn3d.scale, realWidth, realHeight)

            // return {
            //     ...imgInfo,
            //     scale: image.scale,
            //     widthMm: sizeImg.widthMm,
            //     heightMm: sizeImg.heightMm,
            //     mode: "IMG"
            // }

            return {
                ...actualTextOn3d,
                // scale: actualTextOn3d.scale,
                width: actualTextOn3d.currentDimensions.width,
                height: actualTextOn3d.currentDimensions.height,
                widthMm: sizeText.widthMm,
                heightMm: sizeText.heightMm,
                mode: 'TEXT'
            }
        })
    })
}

/**
 * Función para subir una imagen en base64 a la zona seleccionada para
 * @param {String} base64 imagen en base64 que queremos subir
 * @param {Object} activeZone zona activa en la que queremos subir la imagen
 * @returns {Promise} Promesa con la llamada a la función
 **/
export const uploadFile = async (base64, activeZone, realWidth, realHeight) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (!activeZone?.id) {
        throw new Error("No ha proporcionado la zona activa")
    }

    return apiCall(`design.image.uploadBase64("${base64}")`).then(result => {
        console.log("💻 ~ uploadFile ~ result:", result);

        if (!result?.id) {
            return Promise.reject("No hemos podido subir la imagen");
        }

        return apiCall(`design.image.addToPart(${activeZone.id},${result.id})`).then(() => {
            let imgInfo = result;
            console.log("🚀 ~ returnapiCall ~ imgInfo:", imgInfo)

            return apiCall(`design.image.getListByPart( ${activeZone.id} )`).then(result => {
                let image = result.find(i => i.path == imgInfo.url);
                if (!image) {
                    console.warn("No hemos encontrado la imagen a recuperar la escala", imgInfo, activeZone, result)
                    return;
                }

                let sizeImg = estimateRealMmDimensions(activeZone, imgInfo.width, imgInfo.height, image.scale, realWidth, realHeight)

                return {
                    ...imgInfo,
                    scale: image.scale,
                    widthMm: sizeImg.widthMm,
                    heightMm: sizeImg.heightMm,
                    mode: "IMG"
                }
            })
        });
    }).then(data => {
        console.log("💻 ~ addToPart ", data);
        return data;
    });
}


/**
 * Elimina texto de la zona activa en el canvas 3D.
 * 
 * @param {Object} textInfo - Información del texto a eliminar, debe contener la propiedad `text`.
 * @param {Object} activeZone - La zona activa que contiene el texto, debe contener un `id`.
 * @returns {Promise<void>} - Promesa que se resuelve cuando el texto ha sido eliminado.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona una zona activa válida.
 **/
export const removeText = async (textInfo, activeZone) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    if (!activeZone?.id) {
        throw new Error("No ha proporcionado la zona activa")
    }

    return await apiCall(`design.text.getListByPart(${activeZone.id})`).then(async (result) => {
        let actualTextOn3d = result.find(i => i.text == textInfo.text);
        if (!actualTextOn3d) {
            console.warn("No hemos encontrado el texto a recuperar la escala", textInfo, activeZone, result)
            return;
        }

        return apiCall(`design.text.remove(${actualTextOn3d.id})`)
    })
}


/**
 * Valida y normaliza el identificador de un elemento (imagen o texto).
 * 
 * Convierte objetos con propiedades `url`, `path`, `text` o `id` en strings identificadores.
 * Si ya es un string, lo retorna directamente.
 * 
 * @param {string|Object} id - El identificador o objeto que contiene el identificador del elemento.
 * @param {string} mode - El modo del elemento: `"IMG"` para imágenes o `"TEXT"` para texto.
 * @returns {string} - El identificador normalizado como string.
 * @throws {Error} Si no se proporciona un ID válido.
 * @throws {Error} Si el objeto no contiene propiedades reconocidas (`url`, `path`, `text`, `id`).
 **/
const validateItemId = (id, mode) => {

    let logoId = id;

    if (!logoId) {
        throw new Error("No ha proporcionado un id de logo valido")
    }

    if (typeof logoId !== 'string') {
        // Necesitamos que sea el path, que es lo único que tengo entre identificaciones
        if (mode == "IMG") {
            return logoId?.url ?? logoId?.path ?? "";
        }
        else if (mode == "TEXT") {
            return logoId?.text ?? logoId?.id ?? "";
        }

        if (!logoId) {
            throw new Error("No ha proporcionado un logo válido")
        }
    }

    return logoId;
}


/**
 * Elimina un archivo de imagen asociado a una zona activa.
 *
 * @param {string|Object} logoId - El identificador del logo o un objeto que contiene la URL o el path del logo.
 * @param {Object} activeZone - La zona activa que contiene el logo.
 * @param {number} activeZone.id - El identificador de la zona activa.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido.
 * @returns {Promise<void>} Una promesa que se resuelve cuando la imagen ha sido eliminada.
 **/
export const removeImg = async (id, activeZone) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    const logoId = validateItemId(id, "IMG");

    console.log("CONTROL Buscando imagen a eliminar con ID:", logoId, activeZone);

    return apiCall(`design.image.getListByPart( ${activeZone.id} )`).then(result => {
        let image = result.find(i => i.path == logoId || i.url == logoId);

        if (!image) {
            console.warn("No hemos encontrado la imagen a eliminar", logoId, activeZone, result)
            return;
        }

        return apiCall(`design.image.remove(${image.id})`);
        
    })

    // return apiCall(`design.image.remove(${logoId})`);
}

/**
 * Invierte la orientación de un logo en el canvas 3D según el eje especificado.
 *
 * @param {Object} item - Identificador del logo, puede ser un string o un objeto con propiedades `url` o `path`.
 * @param {Object} activeZone - Zona activa donde se encuentra el logo, debe contener un `id`.
 * @param {string} [axis='X'] - Eje en el que se desea invertir el logo, puede ser 'X' o 'Y'.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido o la zona activa.
 * @throws {Error} Si el eje especificado no es válido.
 * @returns {Promise<void>} Una promesa que se resuelve cuando la operación de inversión se completa.
 **/
export const flipLogo = async (item, activeZone, axis = 'X') => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    const mode = item?.mode;
    const id = validateItemId(item, mode);

    axis = axis.toUpperCase();

    if (axis !== "X" && axis !== "Y") {
        throw new Error("No hemos podido encontrar el eje")
    }

    const isImgMode = mode == "IMG";
    const isTextMode = mode == "TEXT"

    const apiNameMethod = isImgMode ? 'image' : isTextMode ? 'text' : "";

    if (!apiNameMethod) {
        throw new Error("No tenemos un modo válido para hacer flip", apiNameMethod, mode)
    }

    return await apiCall(`design.${apiNameMethod}.getListByPart( ${activeZone.id} )`).then(result => {
        let actualItem = result.find(i => (isImgMode && (i.path == id || i.url == id)) || (isTextMode && i.text == id));

        if (!actualItem) {
            console.warn("No hemos encontrado la imagen a eliminar", id, activeZone, result)
            return;
        }

        return apiCall(`design.${apiNameMethod}.isFlip${axis}(${actualItem.id})`).then(resultFlip => {
            // Tratamos por si viene como un string
            resultFlip = resultFlip == 'true' || resultFlip == true;

            if (resultFlip) {
                return apiCall(`design.${apiNameMethod}.unsetFlip${axis}(${actualItem.id})`);
            }
            else {
                return apiCall(`design.${apiNameMethod}.setFlip${axis}(${actualItem.id})`);
            }
        });   

    })
}

export const isFlipLogo = async (item, activeZone, axis = 'X') => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    const mode = item?.mode;
    const id = validateItemId(item, mode);

    axis = axis.toUpperCase();

    if (axis !== "X" && axis !== "Y") {
        throw new Error("No hemos podido encontrar el eje")
    }

    const isImgMode = mode == "IMG";
    const isTextMode = mode == "TEXT"

    const apiNameMethod = isImgMode ? 'image' : isTextMode ? 'text' : "";

    if (!apiNameMethod) {
        throw new Error("No tenemos un modo válido para hacer flip", apiNameMethod, mode)
    }

    return await apiCall(`design.${apiNameMethod}.getListByPart( ${activeZone.id} )`).then(async result => {
        let actualItem = result.find(i => (isImgMode && (i.path == id || i.url == id)) || (isTextMode && i.text == id));

        if (!actualItem) {
            console.warn("No hemos encontrado la imagen a eliminar", id, activeZone, result)
            return;
        }

        return await apiCall(`design.${apiNameMethod}.isFlip${axis}(${actualItem.id})`).then(resultFlip => {
            // Tratamos por si viene como un string
            resultFlip = resultFlip == 'true' || resultFlip == true;

            return resultFlip
        })

    });
}

/**
 * Invierte la orientación de un logo en el canvas 3D según el eje X
 *
 * @param {Object} item - Identificador del logo, puede ser un string o un objeto con propiedades `url` o `path`.
 * @param {Object} activeZone - Zona activa donde se encuentra el logo, debe contener un `id`.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido o la zona activa.
 * @returns {Promise<void>} Una promesa que se resuelve cuando la operación de inversión se completa.
 **/
export const flipLogoX = (item, activeZone) => flipLogo(item, activeZone, 'X');


/**
 * Invierte la orientación de un logo en el canvas 3D según el eje X
 *
 * @param {Object} item - Identificador del logo, puede ser un string o un objeto con propiedades `url` o `path`.
 * @param {Object} activeZone - Zona activa donde se encuentra el logo, debe contener un `id`.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido o la zona activa.
 * @returns {Promise<void>} Una promesa que se resuelve cuando la operación de inversión se completa.
 **/
export const flipLogoY = (item, activeZone) => flipLogo(item, activeZone, 'Y');


/**
 * Rota un logo en el canvas 3D.
 *
 * @param {Object} item - Identificador del logo o un objeto que contiene `url` o `path`.
 * @param {Object} activeZone - Zona activa donde se encuentra el logo.
 * @param {number|string} incremento - Grados de rotación (debe ser un número o convertible a número).
 * @returns {Promise<void>} Promesa que rota el logo si se encuentra.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido.
 * @throws {Error} Si el incremento no es un número.
 **/
export const rotateLogo = async (item, activeZone, incremento) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    const mode = item?.mode;
    const id = validateItemId(item, mode);

    if (isNaN(incremento)) {
        throw new Error("El incremento no es un número")
    }

    incremento = parseInt(incremento);

    const isImgMode = mode == "IMG";
    const isTextMode = mode == "TEXT"

    const apiNameMethod = isImgMode ? 'image' : isTextMode ? 'text' : "";

    if (!apiNameMethod) {
        throw new Error("No tenemos un modo válido para hacer flip", apiNameMethod, mode)
    }

    return await apiCall(`design.${apiNameMethod}.getListByPart( ${activeZone.id} )`).then(result => {
        let actualItem = result.find(i => (isImgMode && (i.path == id || i.url == id)) || (isTextMode && i.text == id));

        if (!actualItem) {
            console.warn("No hemos encontrado la imagen a eliminar", item, activeZone, result)
            return;
        }

        return apiCall(`design.${apiNameMethod}.rotate(${actualItem.id},${incremento} )`);

    })
}

/**
 * Escala un logo en una zona activa específica dentro del canvas 3D.
 *
 * @param {Object} item - Identificador del logo a escalar. Puede ser un string (path o URL) 
 *                                 o un objeto que contenga las propiedades `url` o `path`.
 * @param {Object} activeZone - Objeto que representa la zona activa donde se encuentra el logo.
 *                              Debe contener al menos la propiedad `id`.
 * @param {number|string} scale - Valor de escala a aplicar al logo. Debe ser un número o un string 
 *                                convertible a número.
 * @returns {Promise<void>} Una promesa que se resuelve cuando la operación de escalado se completa.
 * @throws {Error} Si el canvas 3D no está inicializado.
 * @throws {Error} Si no se proporciona un logo válido.
 * @throws {Error} Si el incremento de escala no es un número.
 **/
export const scaleLogo = async (item, activeZone, scale) => {
    if (!checkIsInitialized()) {
        throw new Error("El canvas 3D no está inicializado")
    }

    const mode = item?.mode;
    const id = validateItemId(item, mode);

    if (isNaN(scale)) {
        throw new Error("El incremento no es un número")
    }

    scale = parseFloat(scale);
    console.log("🚀 ~ scaleLogo ~ scale:", scale)

    const isImgMode = mode == "IMG";
    const isTextMode = mode == "TEXT"

    const apiNameMethod = isImgMode ? 'image' : isTextMode ? 'text' : "";

    return await apiCall(`design.${apiNameMethod}.getListByPart( ${activeZone.id} )`).then(result => {
        let actualItem = result.find(i => (isImgMode && (i.path == id || i.url == id)) || (isTextMode && i.text == id));

        if (!actualItem) {
            console.warn("No hemos encontrado la imagen a eliminar", item, activeZone, result)
            return;
        }

        return apiCall(`design.${apiNameMethod}.scale(${actualItem.id},${scale})`).then(() => apiCall(`design.${apiNameMethod}.getListByPart(${activeZone.id})`)).then(resultImg => {
            let updatedItem = resultImg.find(i => (isImgMode && (i.path == id || i.url == id)) || (isTextMode && i.text == id));


            if (!updatedItem) {
                console.warn("No hemos encontrado la imagen ya escalada", id, activeZone, result)
                return Promise.reject("No hemos encontrado la imagen a escalar");
            }

            return customDIM.state.callbacks.scene3D.scaleImage3D({ info: updatedItem })
        })
    });
}


/**
 * Restablece el estado del canvas 3D y del objeto customDIM.
 * 
 * Esta función realiza las siguientes acciones:
 * - Establece la bandera `initialized` a `false`.
 * - Limpia el array `partList`.
 * - Establece `principalPart` a `null`.
 * - Reinicia la cola de llamadas a la API `apiCallQueue`.
 * - Restablece varias propiedades del objeto `customDIM.state` a sus estados iniciales.
 **/
export const resetCanvas3d = () => {
    initialized = false;
    partList = [];
    principalPart = null;
    apiCallQueue = Promise.resolve();

    customDIM.state.initialized = false;
    customDIM.state.iframe = null;
    customDIM.state.ready = null;
    customDIM.state.waiting = null;

}

/**
 * Obtiene una captura de pantalla actual con las dimensiones y configuraciones especificadas.
 *
 * @param {Object} [options={}] - Opciones para la captura de pantalla.
 * @param {number} [options.width=460] - Ancho de la imagen.
 * @param {number} [options.height=460] - Altura de la imagen.
 * @param {string} [options.backgroundColor='FFFFFF'] - Color de fondo de la imagen en formato hexadecimal.
 * @param {number} [options.alpha=1] - Nivel de transparencia de la imagen (0 a 1).
 * @returns {Promise<Object>} - Promesa que resuelve con objeto contiendo:
 *   - `info3d`: Información de personalización del canvas 3D.
 *   - `listImgZones`: Array con capturas de pantalla de cada combinación color-zona.
 * @throws {Error} Si no se encuentra la parte principal o de diseño.
 * @throws {Error} Si no se encuentran diseños disponibles.
 
 **/
export const getActualScreenshot = ({width = 512, height = 512, backgroundColor = 'FFFFFF', alpha = 1} = {}) => {
    return apiCall(`scene.getImage(${width}, ${height}, '${backgroundColor}', ${alpha})`);
}

/**
 * Obtiene el diseño actual basado en una lista de diseños.
 * 
 * @param {Array} listDesign - Lista de diseños con información de zona y posición.
 * @param {Array} listColor - Lista de colores a aplicar en el diseño.
 * @returns {Promise<Object>} Promesa que resuelve con el diseño actual, incluyendo información 3D y lista de zonas con imágenes.
 **/
export const getActualDesign = (listDesign, listColor, selectedColorcode) => {
    console.log("🚀 ~ getActualDesign ~ listColor:", listColor)
    return apiCall(`scene.getCustomizationAndLink`).then(result => {
        let actualDesignResult = {
            info3d: result,
            listImgZones: [],
            listPrincipalZoneImages: []
        }

        if (!listDesign.length) {
            return actualDesignResult;
        }

        // Aunque en listDesign tengamos múltiples diseños para una única zona, solo tenemos que mover el modelo a esa zona una vez.
        // Entonces vamos a mapear listDesign en objetos que contenga zona y posicion del listDesign
        // Evitando aquellas zonas que no tengan idImg (no tienen personalización) y aquellas que ya se encuentre dentro la combinación Zona-Posicion
        const filteredList = listDesign.reduce((accumulator, current) => {
            if (current.idImg) {
                const key = `${current.zona}-${current.posicion}`; // Creas una "clave única" combinando Zona y Posición.

                if (!accumulator.seenKeys.has(key)) {
                    accumulator.seenKeys.add(key);
                    accumulator.filtered.push({
                        Zona: current.zona,
                        Posicion: current.posicion,
                        Animation: 0
                    });
                }
            }
            return accumulator;
        }, { seenKeys: new Set(), filtered: [] }).filtered;

        if(!filteredList.length) {
            return actualDesignResult;
        }

        return new Promise((resolve, reject) => {
            let listPromises = Promise.resolve();

            try {
                principalPart = getPrincipalPart();
            }
            catch (error) {
                console.warn(error);

                designPart = getDesignPart();
            }

            let lastColor = null;
            let currentColorCodeOnModel = selectedColorcode;

            listColor.forEach((color) => {
                lastColor = color
                console.log("🚀 ~ listColor.forEach ~ color:", color)

                if (principalPart) {
                    listPromises = listPromises.then(() => apiCall(`part.setActive(${principalPart.id}, 0)`));
                }

                if (color.code != currentColorCodeOnModel) {
                    if (!color || color.hexcode.includes("/")) {
                        listPromises = listPromises.then(() => {
                            if (!designList || !designList.length) {
                                return Promise.reject("No hemos encontrado la parte de diseño")
                            }

                            const colorCode = color.code

                            let colorToChange = designList.find(c => c.sku?.sku == colorCode);

                            if (!colorToChange || !colorToChange.id) {
                                return Promise.reject("No hemos encontrado el color en la parte de diseño " + colorCode)
                            }

                            console.log("TEST 1 => ", designPart.id, colorToChange.id);
                            return apiCall(`design.setActiveByPart( ${designPart.id}, '${colorToChange.id}' )`);
                        });
                    }
                    else {
                        listPromises = listPromises.then(() => apiCall(`design.setColourOfPieceByPart( ${principalPart.id}, 0, '${color.hexcode.replace("#", "")}' )`));
                    }
                    currentColorCodeOnModel = color.code;
                }

                if (principalPart) {
                    listPromises = listPromises.then(() => getActualScreenshot()).then((actualImg) => {
                        actualDesignResult.listPrincipalZoneImages.push({
                            color,
                            id: principalPart.id,
                            img: actualImg
                        });
                    });
                }

                filteredList.forEach((item) => {
                    listPromises = listPromises.then(() => setActiveZone(item).then(() => getActualScreenshot()).then((actualImg) => {

                        console.log("TEST 2 => ", actualImg)
                        actualDesignResult.listImgZones.push({
                            color,
                            ...item,
                            img: actualImg
                        });
                    }))
                })
            });

            const originalColor = listColor.find(c => c.code == selectedColorcode);
            console.log("🚀 ~ returnnewPromise ~ originalColor:", originalColor)

            if (lastColor && lastColor.code != originalColor.code) {
                if (!originalColor || originalColor.hexcode.includes("/")) {
                    listPromises = listPromises.then(() => {
                        if (!designList || !designList.length) {
                            return Promise.reject("No hemos encontrado la parte de diseño")
                        }

                        const colorCode = originalColor.code

                        let colorToChange = designList.find(c => c.sku?.sku == colorCode);

                        if (!colorToChange || !colorToChange.id) {
                            return Promise.reject("No hemos encontrado el color en la parte de diseño " + colorCode)
                        }
                        console.log("TEST 3 => ", designPart.id, colorToChange.id);
                        return apiCall(`design.setActiveByPart( ${designPart.id}, '${colorToChange.id}' )`);
                    });
                }
                else {

                    listPromises = listPromises.then(() => apiCall(`design.setColourOfPieceByPart( ${principalPart.id}, 0, '${originalColor.hexcode.replace("#", "")}' )`));
                }   
            }
            

            listPromises = listPromises.then(() => resolve(actualDesignResult)).catch(reject);
        })


    });
}